import { render, staticRenderFns } from "./JokerOption.vue?vue&type=template&id=64da1432&scoped=true&"
import script from "./JokerOption.vue?vue&type=script&lang=ts&"
export * from "./JokerOption.vue?vue&type=script&lang=ts&"
import style0 from "./JokerOption.vue?vue&type=style&index=0&id=64da1432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da1432",
  null
  
)

export default component.exports